import { createApp } from 'vue';
import App from '../components/projectMonitoring/ProjectMonitoring.vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

window.createProjectMonitoring = function createProjectMonitoring(divId, props=null) {
  createApp(App, props).use(ElementPlus).mount(`#${divId}`);
};
